import { post as axiosPost, get as axiosGet, put as axiosPut, del as axiosDelete } from '@/security/Axios';
import ApiErrorHandler from './ApiErrorHandler';

const DEBUG_DEFAULT = false;
function isDebugOn() { try { return (typeof window !== 'undefined' && !!window.__DEBUG__) || DEBUG_DEFAULT; } catch { return DEBUG_DEFAULT; } }
function dbg(...a) { if (isDebugOn()) console.log('[apiService]', ...a); }

/**
 * @param {Object} args
 * @param {'GET'|'POST'|'PUT'|'DELETE'} args.method
 * @param {string} args.url               e.g. '/auth/login'
 * @param {Object|null} args.data
 * @param {Function} args.onSuccess       (dispatch, res) => void
 * @param {Function} args.onFailure       (dispatch, errorObj) => void
 * @param {Object|null} args.headers      Optional per-request headers
 */
export function apiService({
  method = 'GET',
  url,
  data = null,
  onSuccess = () => {},
  onFailure = () => {},
  headers = null,
}) {
  return (dispatch) => new Promise((resolve, reject) => {
    const config = {};
    if (headers) config.headers = headers;

    let request;
    const methodU = method.toUpperCase();

    if (isDebugOn()) {
      const preview = data && typeof data === 'object' ? { ...data } : data;
      if (preview?.password) preview.password = '••••••';
      console.groupCollapsed(`[apiService] ${methodU} ${url}`);
      console.log('data:', preview);
      console.log('headers:', headers);
      console.groupEnd();
    }

    switch (methodU) {
      case 'POST': request = axiosPost(url, data, config); break;
      case 'GET':  request = data ? axiosGet(url, { params: data, ...config }) : axiosGet(url, config); break;
      case 'PUT':  request = axiosPut(url, data, config); break;
      case 'DELETE': request = axiosDelete(url, { data, ...config }); break;
      default: {
        const err = new Error(`Unsupported HTTP method: ${method}. Expected: POST, GET, PUT, DELETE.`);
        if (isDebugOn()) dbg('rejecting:', err);
        reject(err);
        return;
      }
    }

    request
      .then((res) => {
        try { onSuccess(dispatch, res); } catch (cbErr) { dbg('onSuccess callback error:', cbErr); }
        resolve(res);
      })
      .catch((err) => {
        const errorData = ApiErrorHandler(err); // toasts + normalized
        try { onFailure(dispatch, errorData); } catch (cbErr) { dbg('onFailure callback error:', cbErr); }
        reject(errorData);
      });
  });
}
